import { render, staticRenderFns } from "./RefTagsList.vue?vue&type=template&id=6331f9fc&scoped=true"
import script from "./RefTagsList.vue?vue&type=script&lang=js"
export * from "./RefTagsList.vue?vue&type=script&lang=js"
import style0 from "./RefTagsList.vue?vue&type=style&index=0&id=6331f9fc&prod&lang=scss&scoped=true"
import style1 from "./RefTagsList.vue?vue&type=style&index=1&id=6331f9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331f9fc",
  null
  
)

export default component.exports